var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-store-first"},[_c('Header'),_c('main',[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"cart-info-alert d-none d-xl-block bg-primary"}),_vm._t("default")],2)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }